/** Изображения карт, которые реально лежат в public/landing (кадры из игры: Valve, через MurkyYT/cs2-map-icons). Остальным карты нужна нейтральная заглушка. */
const IMAGES: Record<string, string> = {
  dust2: "/landing/dust2.jpg",
  nuke: "/landing/nuke.jpg",
  overpass: "/landing/overpass.jpg",
  mirage: "/landing/mirage.jpg",
  inferno: "/landing/inferno.jpg",
  ancient: "/landing/ancient.jpg",
  anubis: "/landing/anubis.jpg",
  vertigo: "/landing/vertigo.jpg",
  train: "/landing/train.jpg",
};

export function mapImage(map: string | null | undefined): string | null {
  if (!map) return null;
  const id = map.replace(/^(de|cs|ar)_/i, "").toLowerCase();
  return IMAGES[id] || null;
}
